const ACTION_SCOPE = '[AprilMadnessEvent]';

export class GetAprilMadnessEventState {
  static readonly type = `${ACTION_SCOPE} Get AprilMadness Event State`;

  constructor(readonly loadAnyway = false) {}
}

export class TakeReward {
  static readonly type = `${ACTION_SCOPE} Take Reward`;

  constructor(readonly levelQuestLevelId: number) {}
}

export class GetMotivator {
  static readonly type = `${ACTION_SCOPE} Get Motivator`;
}

export class GetPossibleItems {
  static readonly type = `${ACTION_SCOPE} Get Possible Items`;
}

export class Replay {
  static readonly type = `${ACTION_SCOPE} Replay`;

  constructor(
    readonly openUUID: string,
    readonly levelQuestLevelId: number,
  ) {}
}

export class CollectLevelReward {
  static readonly type = `${ACTION_SCOPE} Collect Level Reward`;

  constructor(readonly levelBackendId: number) {}
}
